import { Component } from '@angular/core';

@Component({
  selector: 'zc-modal-body',
  templateUrl: './modal-body.component.html',
})
export class ModalBodyComponent {}
